import React, { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate, useLocation, Link, useMatch } from 'react-router-dom';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import '../styles/components/Navigation.scss';
import { UserContext } from '../UserContext';
import { auth, storage } from '../config/firebasedeconfig';
import { getFirestore, doc, updateDoc, getDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { defaultAvatarUrl, defaultUsername, defaultEmail } from '../constants';
import { signOut } from "firebase/auth";
import { OnlineUsersContext } from '../OnlineUsersContext';
import OnlineUsersSidebar from '../onlinelateralusers';
import { RefreshContext } from '../components/RefreshContext';
import { RefreshProvider } from '../components/RefreshContext';
import BlinkingText from './BlinkingText';
import Slogan from './Slogan';
import NotificationsPanel from './NotificationsPanel';
import { collection, query, where, getDocs, onSnapshot } from "firebase/firestore";
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';
import UserXpAvatar from "./UserXpAvatar";
import { getMembershipState } from "../utils/membershipUtils";
import {
    getDisplayActivityScore,
    getLevelTitle,
    getUserActivityScore,
} from "./levelUtils";
// Create a storage reference from our storage service
const storageRef = ref(storage);
const db = getFirestore();

const NavigationBar = () => {
    const { t } = useLanguage();
    const history = useNavigate();
    const { refreshNeeded, setRefreshNeeded } = useContext(RefreshContext);
    const { userId } = useContext(UserContext);
    const [showNotifications, setShowNotifications] = useState(false);
    const [unreadNotifications, setUnreadNotifications] = useState(0);
    const [navActivityScore, setNavActivityScore] = useState(0);
    const displayNavActivityScore = getDisplayActivityScore(navActivityScore, userId);
    const navLevelKey = getLevelTitle(displayNavActivityScore);
    const navLevelTitle = t(`forum.levelTitles.${navLevelKey}`);

    const [navSubscription, setNavSubscription] = useState({
        planId: "free",
        status: "none",
        currentPeriodEnd: null,
        accessOverridePlanId: null,
        accessOverrideUntil: null,
    });

    const {
        effectiveTier: navEffectiveTier,
        hasPaidAccess: navSubscriptionHasAccess,
        billingStatus: navBillingStatus,
    } = getMembershipState(navSubscription);

    const navPlanId = navEffectiveTier;

    const navSubscriptionPlanLabel =
        navEffectiveTier === "cinephile"
            ? t("navigation.subscriptionStatus.cinephile")
            : navEffectiveTier === "fanatic"
                ? t("navigation.subscriptionStatus.fanatic")
                : t("navigation.subscriptionStatus.free");

    const navSubscriptionStatusLabel =
        navBillingStatus === "cancelled"
            ? t("navigation.subscriptionStatus.cancelled")
            : navSubscriptionHasAccess
                ? t("navigation.subscriptionStatus.active")
                : t("navigation.subscriptionStatus.inactive");

    const navSubscriptionText =
        navEffectiveTier === "free"
            ? t("navigation.subscriptionStatus.free")
            : `${navSubscriptionPlanLabel} • ${navSubscriptionStatusLabel}`;

    const navigateToProfilMember = () => {
        const newUrl = history(`/profilMemberPage/${userId}?showAnimation=true`);  // Adjust as needed

    };

    const location = useLocation();
    const [selectedCategoryName, setSelectedCategoryName] = useState("");
    const { username, email, avatar, isLoggedIn, resetContext, setUsername, setEmail, setAvatar, setIsLoggedIn } = useContext(UserContext);
    const userIsLoggedIn = username !== null && username !== "";
    const [isSidebarOpen, setSidebarOpen] = useState(false); // Nouvel état pour la barre latérale
    const onlineUsers = useContext(OnlineUsersContext); // Récupère les utilisateurs en ligne depuis le contexte




    // Function to open the sidebar
    const openSidebar = () => {
        setSidebarOpen(true);
    };

    // Function to close the sidebar
    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    // console.log("Test de Username:", username);
    // console.log("Test de Email:", email);
    // console.log("Test de Avatar:", avatar);
    // console.log("Test de isLoggedIn:", isLoggedIn);
    // console.log("Test de userIsLoggedIn:", userIsLoggedIn);


    useEffect(() => {
        console.log("Debug username from ProfilMember:", username); // Affiche le nom d'utilisateur dans la console
        const fetchData = async () => {
            try {
                if (auth.currentUser) {
                    const userDoc = doc(db, 'users', auth.currentUser.uid);
                    const docSnap = await getDoc(userDoc);
                    if (docSnap.exists()) {
                        const data = docSnap.data();

                        setAvatar(data.avatar ? data.avatar : defaultAvatarUrl);
                        setUsername(data.username ? data.username : defaultUsername);
                        setEmail(data.email ? data.email : defaultEmail);

                        setNavActivityScore(
                            getUserActivityScore(data, data.messageCount ?? 0)
                        );
                    }
                }

            } catch (error) {
                console.error("Une erreur est survenue lors de la récupération des données :", error);
                // Vous pouvez également définir un état d'erreur ici si vous le souhaitez
            }
        };

        fetchData();
    }, [userId, refreshNeeded, setRefreshNeeded, username, email, avatar, isLoggedIn, resetContext, setUsername, setEmail, setAvatar]);

    useEffect(() => {
        if (!userId) {
            setNavSubscription({
                planId: "free",
                status: "none",
                currentPeriodEnd: null,
                accessOverridePlanId: null,
                accessOverrideUntil: null,
            });
            return;
        }

        const userRef = doc(db, "users", userId);

        const unsubscribe = onSnapshot(
            userRef,
            (snapshot) => {
                if (!snapshot.exists()) return;

                const subscription = snapshot.data()?.subscription;

                setNavSubscription({
                    planId: subscription?.planId || "free",
                    status: subscription?.status || "none",
                    currentPeriodEnd: subscription?.currentPeriodEnd || null,
                    accessOverridePlanId:
                        subscription?.accessOverridePlanId || null,
                    accessOverrideUntil:
                        subscription?.accessOverrideUntil || null,
                });
            },
            (error) => {
                console.error(
                    "Erreur écoute abonnement Navigation :",
                    error
                );
            }
        );

        return () => unsubscribe();
    }, [userId]);

    useEffect(() => {
        const handleSubscriptionUpdated = (event) => {
            const {
                planId,
                status,
                currentPeriodEnd,
                accessOverridePlanId,
                accessOverrideUntil
            } = event.detail || {};

            if (!planId || !status) return;

            console.log("[NAV] abonnement mis à jour immédiatement :", {
                planId,
                status,
            });

            setNavSubscription((previousSubscription) => ({
                planId,
                status,

                currentPeriodEnd:
                    currentPeriodEnd ??
                    previousSubscription.currentPeriodEnd ??
                    null,

                accessOverridePlanId:
                    accessOverridePlanId !== undefined
                        ? accessOverridePlanId
                        : previousSubscription.accessOverridePlanId ?? null,

                accessOverrideUntil:
                    accessOverrideUntil !== undefined
                        ? accessOverrideUntil
                        : previousSubscription.accessOverrideUntil ?? null,
            }));
        };

        window.addEventListener(
            "mf-subscription-updated",
            handleSubscriptionUpdated
        );

        return () => {
            window.removeEventListener(
                "mf-subscription-updated",
                handleSubscriptionUpdated
            );
        };
    }, []);


    // Function to handle sign out
    const handleSignOut = () => {
        auth.signOut()
            .then(() => {
                console.log("User signed out");
                resetContext();  // Utilisez la fonction ici
                history("/");
            })
            .catch((error) => {
                console.log(error);
            });
    };




    const handleCategoryClick = (id, name) => {
        setSelectedCategoryName(name);
        history(`/categories/${id}`);
    };

    const handleSelectCategoriesClick = () => {
        setSelectedCategoryName("");
        history('/categories');
    };

    // Get the current category name from the URL path
    const getCurrentCategoryName = () => {
        const path = location.pathname;
        const parts = path.split('/');
        if (parts.length >= 3) {
            return parts[2];
        }
        return "";
    };

    useEffect(() => {
        const categoryName = getCurrentCategoryName();
        setSelectedCategoryName(categoryName);
    }, [location.pathname]);

    const {
        setIsLoggedIn: fetchUserData, updateContext
    } = useContext(UserContext);

    // Fonction pour gérer la déconnexion


    const handleLogout = async () => {
        const user = auth.currentUser; // Vérifie l'utilisateur actuellement connecté
        if (user) {
            try {
                // Étape 1 : Mettre à jour Firestore AVANT de déconnecter
                const userRef = doc(db, "users", user.uid);
                await updateDoc(userRef, { isOnline: false });
                console.log("Statut isOnline mis à jour dans Firestore : false");

                // Étape 2 : Déconnecter l'utilisateur
                await signOut(auth);
                console.log("Utilisateur déconnecté avec succès.");

                // Étape 3 : Réinitialiser les états locaux et rediriger
                updateContext(null, null, null, false);

                // 🔧 NOUVEAU : Réinitialiser les états de notifications
                setShowNotifications(false);
                setUnreadNotifications(0);

                // 🔧 NOUVEAU : Forcer le rechargement de la page pour un nettoyage complet
                window.location.href = '/'; // Utilise window.location au lieu de history pour forcer le rechargement
            } catch (error) {
                console.error("Erreur lors de la déconnexion :", error);
            }
        } else {
            console.warn("Aucun utilisateur connecté pour effectuer la déconnexion.");
        }
    };


    const CustomNavLink = ({ to, children, end = false }) => {
        // useMatch doit être utilisé à l'intérieur d'un composant fonctionnel
        const match = useMatch({
            path: to,
            end: end,
        });


        return (
            <Nav.Link
                as={NavLink}
                to={to}
                className={match ? "nav-active nav-link-custom font-weight-bolder mx-4 align-items-center" : "nav-link-custom font-weight-bolder mx-4 align-items-center"}
            >
                {children}
            </Nav.Link>
        );
    };

    // Récupérer le nombre de notifications non lues
    useEffect(() => {
        if (!userId) return;

        const fetchUnreadNotifications = async () => {
            try {
                // Utiliser une requête Firestore pour compter les notifications non lues
                const notificationsRef = collection(db, 'users', userId, 'notifications');
                const q = query(notificationsRef, where('read', '==', false));
                const querySnapshot = await getDocs(q);
                setUnreadNotifications(querySnapshot.size);
            } catch (error) {
                console.error("Erreur lors de la récupération des notifications non lues:", error);
            }
        };

        fetchUnreadNotifications();

        // Mettre en place un écouteur pour les mises à jour en temps réel
        const notificationsRef = collection(db, 'users', userId, 'notifications');
        const q = query(notificationsRef, where('read', '==', false));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setUnreadNotifications(snapshot.size);
        });

        return () => {
            unsubscribe();
        };
    }, [userId]);

    // Gérer la fermeture du panneau de notifications
    const handleCloseNotifications = () => {
        setShowNotifications(false);
    };

    return (
        <>
            <OnlineUsersSidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
            <NotificationsPanel isOpen={showNotifications} onClose={handleCloseNotifications} />
            <Navbar expand="lg" className={`navigation w-100 navbar-expand-lg ${location.pathname === '/Propos' ? 'bg-gradient' : 'bg-gradient'}`} >
                <Container className="align-items-center containerNav">
                    <NavLink to="/" className={({ isActive }) => (isActive ? "nav-active navbar-brand" : "navbar-brand")}>
                        <div className="logoNavbarContainer">
                            <span className="mf-whimsy-logo">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/newColorLogoMovieFrenzy_01.png`}
                                    alt="logo"
                                    width="100"
                                    height="100"
                                    className="logoNavbar"
                                    onMouseOver={(e) =>
                                        e.target.src = `${process.env.PUBLIC_URL}/images/newColorLogoMovieFrenzy_Opacity01.png`
                                    }
                                    onMouseOut={(e) =>
                                        e.target.src = `${process.env.PUBLIC_URL}/images/newColorLogoMovieFrenzy_01.png`
                                    }
                                />

                                <span
                                    className="mf-logo-particle mf-logo-particle--cyan"
                                    aria-hidden="true"
                                />

                                <span
                                    className="mf-logo-particle mf-logo-particle--magenta"
                                    aria-hidden="true"
                                />

                                <span
                                    className="mf-logo-particle mf-logo-particle--pink"
                                    aria-hidden="true"
                                />
                            </span>

                            <Slogan />
                        </div>
                    </NavLink>
                    <div className="box-blink">
                        <BlinkingText />
                    </div>
                    <Navbar.Toggle aria-controls="navbarScroll">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" className="bi bi-list" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                        </svg>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbarScroll">
                        <Nav className="ms-auto my-2 my-lg-0 justify-content-end align-items-center d-flex">
                            <CustomNavLink to="/" end={true} >{t('navigation.home')}</CustomNavLink>
                            <NavDropdown
                                title={t('navigation.categories')}
                                id="navbarScrollingDropdown"
                                className={`custom-dropdown-menu ${location.pathname.includes('/categories') ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    onClick={handleSelectCategoriesClick}
                                    className="allCategorySelect"
                                >
                                    {t('navigation.selectCategories')}
                                </NavDropdown.Item>
                                <NavDropdown.Item className="dropdown-menu d-flex align-items-center">
                                    <Nav className="flex-wrap align-items-center">
                                        <Nav.Link onClick={() => handleCategoryClick(28, "Action")} className="dropdown-item">{t('categories.action')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(16, "Animation")} className="dropdown-item">{t('categories.animation')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(12, "Aventure")} className="dropdown-item">{t('categories.adventure')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(35, "Comédie")} className="dropdown-item">{t('categories.comedy')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(80, "Crime")} className="dropdown-item">{t('categories.crime')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(99, "Documentaire")} className="dropdown-item">{t('categories.documentary')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(18, "Drame")} className="dropdown-item">{t('categories.drama')}</Nav.Link>
                                    </Nav>
                                    <Nav className="flex-wrap align-items-center">
                                        <Nav.Link onClick={() => handleCategoryClick(10751, "Familial")} className="dropdown-item">{t('categories.family')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(14, "Fantastique")} className="dropdown-item">{t('categories.fantasy')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(10752, "Guerre")} className="dropdown-item">{t('categories.war')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(36, "Histoire")} className="dropdown-item">{t('categories.history')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(27, "Horreur")} className="dropdown-item">{t('categories.horror')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(10402, "Musique")} className="dropdown-item">{t('categories.music')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(9648, "Mystère")} className="dropdown-item">{t('categories.mystery')}</Nav.Link>
                                    </Nav>
                                    <Nav className="flex-wrap align-items-center">
                                        <Nav.Link onClick={() => handleCategoryClick(10749, "Romance")} className="dropdown-item">{t('categories.romance')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(878, "Science-fiction")} className="dropdown-item">{t('categories.sciFi')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(53, "Thriller")} className="dropdown-item">{t('categories.thriller')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(10770, "Téléfilm")} className="dropdown-item">{t('categories.tvMovie')}</Nav.Link>
                                        <Nav.Link onClick={() => handleCategoryClick(37, "Western")} className="dropdown-item">{t('categories.western')}</Nav.Link>
                                        {userIsLoggedIn && (
                                            <Nav.Link as={NavLink} to="/claude-test" className="mx-2 align-items-center">
                                                <img src="/images/claude-icon.png" alt="Claude" style={{ width: 30, height: 30 }} />
                                            </Nav.Link>
                                        )}
                                    </Nav>
                                </NavDropdown.Item>
                            </NavDropdown>
                            <CustomNavLink to="/Propos" end={true}><span id="itemProposSuperZIndex">{t('navigation.about')}</span></CustomNavLink>
                            <Nav.Link
                                as={NavLink}
                                end
                                to="/recherche"
                                className={`mx-3 align-items-center ${location.pathname === "/recherche" ? "nav-active" : ""
                                    }`}
                            >
                                <i className="fas fa-search icon custom-icon"></i>
                            </Nav.Link>
                            <li>
                                <LanguageSelector />
                            </li>

                            {/* Affiche le lien vers Claude pour les utilisateurs connectés */}
                            {userIsLoggedIn && (
                                <li className="claude-nav-item">
                                    <NavLink
                                        to="/claude-test"
                                        className="navLink claude-nav-link"
                                        title="Assistant Claude MovieFrenzy"
                                    >
                                        <img
                                            src="/images/claude-icon.png"
                                            alt="Assistant Claude MovieFrenzy"
                                            className="iconClaudeCherry"
                                        />
                                        <span className="claude-label d-none d-lg-inline">Claude</span>
                                    </NavLink>
                                </li>
                            )}
                            <Nav.Link onClick={() => setShowNotifications(!showNotifications)} className="mx-3 align-items-center position-relative">
                                <i className={`fas fa-bell icon custom-icon ${unreadNotifications > 0 ? 'notification-icon-active' : ''}`}></i>
                                {unreadNotifications > 0 && (
                                    <span className="notification-badge position-absolute" style={{
                                        top: '-5px',
                                        right: '-5px',
                                        backgroundColor: '#FF33CC',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        fontSize: '0.8rem',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)'
                                    }}>
                                        {unreadNotifications > 9 ? '9+' : unreadNotifications}
                                    </span>
                                )}
                            </Nav.Link>
                            <Nav.Item className="mx-3 align-items-center" >
                                <NavDropdown title={<>
                                    <span className="d-none d-lg-inline" style={userIsLoggedIn ? { backgroundColor: "#000", color: "#00FFFF", padding: "5px", border: "1px solid #00FFFF", borderRadius: "5px" } : {}}>{username || t('navigation.username')}</span>
                                    {/* <span className="avatar3 me-2" style={userIsLoggedIn ? {
                                        border: "1px solid #00FFFF",
                                        marginTop: "1vh",
                                        overflowX: "hidden",
                                        overflowY: "hidden",
                                        width: "65px",
                                        height: "65px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    } : {}}>
                                        {userIsLoggedIn ? (avatar ? <img src={avatar} alt="Avatar" style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "50%"
                                        }} /> : <img src={defaultAvatarUrl} alt="Default Avatar" style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "50%"
                                        }} />) : <i className="fas fa-user"></i>}
                                    </span> */}
                                    <span className="avatar3 me-2 navigation-xp-avatar">
                                        {userIsLoggedIn ? (
                                            <UserXpAvatar
                                                avatarUrl={avatar || defaultAvatarUrl}
                                                activityScore={displayNavActivityScore}
                                                userId={userId}
                                                showTitle={false}
                                                showActivity={false}
                                                className="user-xp-avatar--nav-compact"
                                                id="imgAvatarIDNavDropdown"
                                            />
                                        ) : (
                                            <i className="fas fa-user"></i>
                                        )}
                                    </span>
                                </>} id="navbarScrollingDropdown2" className="custom-dropdown-menu">
                                    <NavDropdown.Header>
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex align-items-center me-3" style={{ border: `1px solid #FF33CC`, padding: `0.25rem` }}>
                                                {/* <div className="avatar3a me-2" style={{
                                                    width: "65px",
                                                    height: "65px",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    {userIsLoggedIn ? (avatar ? <img src={avatar} alt="Avatar" style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "50%"
                                                    }} /> : <img src={defaultAvatarUrl} alt="Default Avatar" style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "50%"
                                                    }} />) : <i className="fas fa-user" style={{ color: '#D90093' }}></i>}
                                                </div> */}
                                                <div className="avatar3a me-2 navigation-xp-avatar navigation-xp-avatar--dropdown">
                                                    {userIsLoggedIn ? (
                                                        <UserXpAvatar
                                                            avatarUrl={avatar || defaultAvatarUrl}
                                                            activityScore={displayNavActivityScore}
                                                            userId={userId}
                                                            showTitle={false}
                                                            showActivity={false}
                                                            className="user-xp-avatar--nav-compact"
                                                            id="imgAvatarIDNavDropdown"
                                                        />
                                                    ) : (
                                                        <i className="fas fa-user" style={{ color: "#D90093" }}></i>
                                                    )}
                                                </div>
                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize: "24px",
                                                            fontWeight: "400",
                                                            color: username ? "#00FFFF" : "#FFFFFF"
                                                        }}
                                                    >
                                                        {username || t('navigation.username')}
                                                    </div>
                                                    <div style={{ fontSize: "14px", color: "#ffffff" }}>
                                                        {email || defaultEmail}
                                                    </div>

                                                    {userIsLoggedIn && (
                                                        <div
                                                            style={{
                                                                marginTop: "0.25rem",
                                                                fontSize: "0.78rem",
                                                                color: "#FF33CC",
                                                                fontWeight: "700",
                                                                textShadow: "0 0 0.35rem rgba(255, 51, 204, 0.7)",
                                                            }}
                                                        >
                                                            {navLevelTitle}
                                                        </div>
                                                    )}
                                                    {userIsLoggedIn && (
                                                        <div
                                                            className={`
            navigation-subscription-status
            navigation-subscription-status--${navPlanId}
${navSubscriptionHasAccess
                                                                    ? "navigation-subscription-status--active"
                                                                    : "navigation-subscription-status--inactive"
                                                                }
        `}
                                                        >
                                                            <span className="navigation-subscription-status__dot" />
                                                            <span>{navSubscriptionText}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </NavDropdown.Header>
                                    <Nav.Item className="d-flex">
                                        <Nav className="flex-wrap">
                                            <NavDropdown.Item as={Link} to={auth.currentUser ? `/profilMemberPage/${userId}` : '/connexion'}>
                                                <i className="fas fa-user me-2"></i>{t('navigation.myProfile')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/creercompte">
                                                <i className="fas fa-cog me-2"></i>{t('navigation.createAccount')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to={auth.currentUser ? `/EditProfilPage/${userId}` : '/connexion'}>
                                                <i className="fas fa-user me-2"></i>{t('navigation.manageProfile')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item>
                                                <i className="fas fa-sliders-h me-2"></i>{t('navigation.settings')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item onClick={openSidebar}>
                                                <i className="fas fa-users me-2"></i> {t('navigation.whoIsOnline')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/Abonnement">
                                                <i className="fas fa-ticket-alt me-2"></i>{t('navigation.abonnement')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/Forum">
                                                <i className="fas fa-comments me-2"></i>{t('navigation.forum')}
                                            </NavDropdown.Item> {/* Nouvelle entrée pour le forum */}
                                            <NavDropdown.Item>
                                                <i className="fas fa-question-circle me-2"></i>{t('navigation.helpCenter')}
                                            </NavDropdown.Item>
                                            <NavDropdown.Item
                                                onClick={() => {
                                                    if (isLoggedIn) {
                                                        handleLogout();
                                                    } else {
                                                        history("/connexion"); // Redirection vers la page de connexion
                                                    }
                                                }}
                                            >
                                                <i className="fas fa-sign-out-alt me-2"></i>
                                                {!isLoggedIn ? t('navigation.login') : t('navigation.logout')}
                                            </NavDropdown.Item>
                                        </Nav>
                                    </Nav.Item>
                                </NavDropdown>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar >
        </>
    );
};

export default NavigationBar;
